import { z } from 'zod';

const SourceSchema = z.object({
  file: z.string().min(1),
  line: z.number().int().optional()
}).optional();

export const EnumDefinitionSchema = z.object({
  name: z.string().min(1),
  values: z.array(z.string().min(1)),
  source: SourceSchema
});

export type EnumDefinition = z.infer<typeof EnumDefinitionSchema>;
